export enum SERVICE_PAYMENT_STATUS {
    NEW = 'NEW',
    CONFIRMED = 'CONFIRMED',
    PENDING = 'PENDING',
    PAID = 'PAID',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
    CANCELED = 'CANCELED',
    RETURNED = 'RETURNED',
    NEEDS_CONFIRMATION = 'NEEDS_CONFIRMATION',
}